/* istanbul ignore file - not worth explicitly testing this hook */
import { useQueryParams } from '@partful/shared/lib/hooks/useQueryParams';
import { useUser } from '@providers/User';
import { GA } from '@services/gtag';
import { useMemo } from 'react';
import { useConfiguration } from 'src/providers/Configuration';
import { useTenant } from 'src/providers/Tenant';

export const useManageProductPageAnalytics = () => {
  const { accountId } = useTenant();
  const { role, username } = useUser();
  const { name: productName } = useConfiguration();

  const { configurationPID } = useQueryParams('configurationPID');

  const configurationEventData = useMemo(
    () => ({
      account: accountId,
      configurationPID,
      productName,
      role: role!,
      user: username!,
    }),
    [accountId, configurationPID, productName, role, username]
  );

  const sendLandedSalesBOMMatchReportEvent = () => {
    GA.ManageProductPage.landedSalesBOMMatchReport(configurationEventData);
  };

  const sendSalesBOMUploadEvent = () => {
    GA.ManageProductPage.salesBOMUpload(configurationEventData);
  };

  const sendMatchReportDownloadEvent = () => {
    GA.ManageProductPage.matchReportDownload(configurationEventData);
  };

  const sendLearnMoreSalesBOMEvent = () => {
    GA.ManageProductPage.learnMoreSalesBOM(configurationEventData);
  };

  const sendMatchReportMissingEvent = () => {
    GA.ManageProductPage.matchReportMissing(configurationEventData);
  };

  return {
    sendLandedSalesBOMMatchReportEvent,
    sendSalesBOMUploadEvent,
    sendMatchReportDownloadEvent,
    sendLearnMoreSalesBOMEvent,
    sendMatchReportMissingEvent,
  };
};
